module.exports = __webpack_public_path__ + "static/media/B43313 - Notice of Proposal to Suspend a Licence.91601d24.pdf";